export default {
    root: {
        fontSize: '22px',
    },
};
